export class RefundRequest {
  centroCostoDestinoId: number;
  monto: number;

  constructor({
    centroCostoDestinoId,
    monto,
  }: {
    centroCostoDestinoId: number;
    monto: number;
  }) {
    this.centroCostoDestinoId = centroCostoDestinoId;
    this.monto = monto;
  }
}
